
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quiz/[id]",
      function () {
        return require("private-next-pages/quiz/[id]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quiz/[id]"])
      });
    }
  